import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';

const withDraggable = (WrappedComponent, withDraggableProps = {}) => {
  class WrappedComponentWithDraggable extends React.Component {
    constructor(props) {
      super(props);
      this.onMove = this.onMove.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
      this.onDragComplete = this.onDragComplete.bind(this);

      this.state = {
        isDragging: false,
      };
    }

    onMove(x, y) {
      if (this.props.isPopupAttachedToMouse) {
        return;
      }
      this.props.onMove(this.props.id, x, y);
    }

    // Triggerd on onMouseDown and will call onMove which will
    // set the active popup.
    onDragStart(ev, data) {
      this.setState({ isDragging: true });
      this.onMove(data.x, data.y);
    }

    onDragComplete(ev, data) {
      this.onMove(data.x, data.y);
      this.setState({ isDragging: false });
    }

    render() {
      const draggableProps = {
        bounds: this.props.bounds || withDraggableProps.bounds || '',
        disabled: !this.props.draggable,
        handle: this.props.dragHandle || withDraggableProps.dragHandle || '',
        position: {
          x: this.props.x,
          y: this.props.y,
        },
        onStart: this.onDragStart,
        onStop: this.onDragComplete,
      };

      return (
        <Draggable {...draggableProps} >
          <WrappedComponent
            {...this.props}
            isDragging={this.state.isDragging}
          />
        </Draggable>
      );
    }
  }

  WrappedComponentWithDraggable.defaultProps = {
    bounds: '',
    draggable: true,
    dragHandle: '',
    isPopupAttachedToMouse: false,
    x: 0,
    y: 0,
  };
  WrappedComponentWithDraggable.propTypes = {
    id: PropTypes.string.isRequired,
    isPopupAttachedToMouse: PropTypes.bool,
    bounds: PropTypes.string,
    draggable: PropTypes.bool,
    onMove: PropTypes.func.isRequired,
    dragHandle: PropTypes.string,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  return WrappedComponentWithDraggable;
};

export default withDraggable;



// WEBPACK FOOTER //
// ./src-react/withDraggable/index.jsx